const DOCUMENT = 'TALENT_SUSPENSION_';

const actions = {
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CONFIRM: DOCUMENT + 'CONFIRM',
  CREATE: DOCUMENT + 'CREATE',
  EDIT: DOCUMENT + 'EDIT',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  REINSTATE: DOCUMENT + 'REINSTATE',
  REINSTATE_SUCCESS: DOCUMENT + 'REINSTATE_SUCCESS',
  TOGGLE_SUSPENSION_MODAL: DOCUMENT + 'TOGGLE_SUSPENSION_MODAL',
  UPDATE: DOCUMENT + 'UPDATE',

  create: () => ({
    type: actions.CREATE,
  }),

  edit: data => ({
    type: actions.EDIT,
    payload: data,
  }),

  confirm: data => ({
    type: actions.CONFIRM,
    payload: data,
  }),

  update: data => ({
    type: actions.UPDATE,
    payload: data,
  }),

  reinstate: data => ({
    type: actions.REINSTATE,
    payload: data,
  }),

  reinstateSuccess: () => ({
    type: actions.REINSTATE_SUCCESS,
  }),

  loadFormData: data => ({
    type: actions.LOAD_FORM_DATA,
    payload: data,
  }),

  loadFormDataSuccess: data => ({
    type: actions.LOAD_FORM_DATA_SUCCESS,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  toggleSuspensionModal: () => ({
    type: actions.TOGGLE_SUSPENSION_MODAL,
  }),
};

export default actions;
